module.exports = __webpack_public_path__ + "static/media/logo_kisde.66cf289f.svg";